// /* --- Function Index --- */
var site = {
  // 1st function to fire
  ready: ready,
  // 2nd function to fire
  load: load,
  scroll: scroll,
  resize: resize,
  responsive: function getResponsive() {
    var windowWidth = window.innerWidth;
    var size;
    if (windowWidth > 768) {
      size = "lg"
    }
    else if (windowWidth <= 768 && windowWidth > 426) {
      size = "md"
    }
    else if (windowWidth <= 426) {
      size = "sm"
    }

    return size
  }
}

function scroll() {
  $(window).on('scroll', function () {
    if ($('#burger-menu').hasClass('show')) {
      $('#burger-menu, .header-menu, body').removeClass('show');
      $('body').removeClass('overflow-hidden');
    }
  });
}

function ready() { 
  scroll();
}

$(document).ready(function () {
  site.ready();
});

function load() {

  $('.loader-component').delay(500).fadeOut('fast');
  $('.loader-image').fadeOut(350);
  $('main').css({
    opacity: 1
  });
}

$(window).on('load', function () {
  site.load();
});


function resize() {
  var r = site.responsive()
}

$(window).on('resize', function () {
  site.resize();
});

// VALIDATE FORMS
(function () {
  'use strict';
  window.addEventListener('load', function () {
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    var forms = document.getElementsByClassName('needs-validation');
    // Loop over them and prevent submission
    var validation = Array.prototype.filter.call(forms, function (form) {
      form.addEventListener('submit', function (event) {
        if (form.checkValidity() === false) {
          event.preventDefault();
          event.stopPropagation();
        }
        form.classList.add('was-validated');
      }, false);
    });
  }, false);
})();

const Util = {
  getSelectorFromElement(element) {
    var selector = element.getAttribute('data-target')
    if (!selector || selector === '#') {
      selector = element.getAttribute('href') || ''
    }

    try {
      return document.querySelector(selector) ? selector : null
    } catch (err) {
      return null
    }
  },
  getIdFromDropdown(element) {
    var selector = element.parentElement.getAttribute("data-id")

    try {
      return document.getElementById(selector) ? document.getElementById(selector) : null
    } catch (err) {
      return null
    }
  }
}

// Toggle Classes for [data-toggle=] HTML tags.
/* PARAMS: 
  class to toggle: data-toggle="class"
  Target to toggle above class: data-target="header, main"
*/
$(function () {
  $(document).on('click', '[data-toggle="show"]', function (event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.currentTarget.tagName === 'A' && $(this).data("prevent") != false) {
      event.preventDefault()
    }

    const $trigger = $(this)
    const selector = Util.getSelectorFromElement(this)
    const selectors = [].slice.call(document.querySelectorAll(selector))
    $(selectors).each(function () {
      const $target = $(this)
      const $data = $trigger.data("toggle")
      $target.toggleClass($data)
      const $focus = $trigger.data("focus")
      if ($focus != "") {
        console.log("focus", $focus)
        $($focus).focus()
      }
    })
  })

  $(document).on('click', '[data-link="offset"]', function (event) {
    const $offset = $(this).data("link-offset");
    const $trigger = $(this).attr("href");
    $('html, body').stop().animate({ scrollTop: $($trigger).offset().top - $offset });
  })
})


// $(document).on("click", ".input-number-increment", function (e) {
//   var quantity = $(this).parent().find("input").val();
//   $(this).parent().find("input").val(parseInt(quantity) + 1).change();
// });

// $(document).on("click", ".input-number-decrement", function (e) {
//   var quantity = $(this).parent().find("input").val();
//   if (quantity <= 1)
//       $(this).parent().find("input").val(1).change();
//   else
//       $(this).parent().find("input").val(parseInt(quantity) - 1).change();
// });

$(document).on('click', function (e) {
  const $menu = $('.header-menu');
  const $burgerTrigger = $('[data-toggle="show"][data-target=".header-menu, #burger-menu"]');
  const toggleClass = $burgerTrigger.data("toggle");

  const isClickInsideMenu = $menu.is(e.target) || $menu.has(e.target).length > 0;
  const isClickOnTrigger = $burgerTrigger.is(e.target) || $burgerTrigger.has(e.target).length > 0;

  if ($menu.hasClass(toggleClass)) {
    // If clicked outside menu and trigger, close the menu
    if (!isClickInsideMenu && !isClickOnTrigger) {
      $menu.removeClass(toggleClass);
      $('#burger-menu').removeClass(toggleClass);
      document.body.classList.remove('overflow-hidden');
    } else {
      document.body.classList.add('overflow-hidden');
    }
  } else {
    document.body.classList.remove('overflow-hidden');
  }
});


//Headroom
$(function() {
  const theHeader = document.querySelector("header");

  let options = {
    offset: 170,
    onPin: function(){
      document.body.classList.add('header-pin');
      if ($('.services-sticky').length){
        $('.services-sticky ').addClass('pin');
      }
      if($('.cryo-accordion.interactive .item').length){
        $('.cryo-accordion.interactive .item').addClass('pin');
      }
    }, 
    onUnpin: function(){
      document.body.classList.remove('header-pin');
      if ($('.services-sticky ').length){
        $('.services-sticky ').removeClass('pin');
      }
      if($('.cryo-accordion.interactive .item').length){
        $('.cryo-accordion.interactive .item').removeClass('pin');
      }
     
    }
  };
  const headroom = new Headroom(theHeader, options);
  headroom.init();
});

//header scroll
const blueHeader = document.querySelector('header');

window.addEventListener('scroll', function () {
  const headerscrollY = window.scrollY || window.pageYOffset;

  if (blueHeader.classList.contains('headroom--not-top')) {
    if (headerscrollY > 150) {
      blueHeader.classList.add('blue-header');
    } else {
      blueHeader.classList.remove('blue-header');
    }
  }
});

window.addEventListener('scroll', function () {
  const headerscrollY = window.scrollY || window.pageYOffset;

  if (blueHeader.classList.contains('blue-header')) {
    if (headerscrollY > 300) {
      blueHeader.classList.add('visible');
    } else {
      blueHeader.classList.remove('visible');
    }
  }
});


